export enum MetadataInspectionStatus {
  WAITING = 'waiting',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}
